import DG from "assets/images/game/LiveCasino/live-dg.png";
import EVO from "assets/images/game/LiveCasino/live-evo.png";
import EZ from "assets/images/game/LiveCasino/live-ezugi.png";
import PP from "assets/images/game/LiveCasino/live-pragmatic.png";
import SX from "assets/images/game/LiveCasino/live-sexy.png";
import { SubGameType } from "types/game";

export const listGameLiveCasino: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "DG",
    type: "LC",
    featured: "NO",
    new_arrive: "NO",
    picture: DG
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "EVO",
    type: "LC",
    featured: "NO",
    new_arrive: "NO",
    picture: EVO
  },
  // {
  //   game_code: "0",
  //   name: "Lobby",
  //   provider_code: "SXB",
  //   type: "LC",
  //   featured: "NO",
  //   new_arrive: "NO",
  //   picture: SXB
  // },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "PP",
    type: "LC",
    featured: "NO",
    new_arrive: "NO",
    picture: PP
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "EZ",
    type: "LC",
    featured: "NO",
    new_arrive: "NO",
    picture: EZ
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "SX",
    type: "LC",
    featured: "NO",
    new_arrive: "NO",
    picture: SX
  }
];
